export const getToolbar = state => state.toolbar;
